// export const arrangeSidebarMenuItems = (items = []) => {
//   const hiddenSidebarLabels = ["Games", "More"];
//   const normalizedItems = items.map((item) => {
//     if (item?.label === "Sports") {
//       return {
//         ...item,
//         path: "/sports",
//         externalUrl: undefined,
//         openInNewTab: undefined,
//         requiresLogin: false,
//         isPublic: true,
//       };
//     }

//     if (item?.label === "Offers" && !item.path && !item.externalUrl && !item.action) {
//       return {
//         ...item,
//         path: "/offers",
//       };
//     }

//     return item;
//   });
//   const visibleItems = normalizedItems.filter((item) => !hiddenSidebarLabels.includes(item?.label));
//   const canRedirect = (item) => Boolean(item?.path || item?.externalUrl || item?.action);
//   const sortedItems = [
//     ...visibleItems.filter(canRedirect),
//     ...visibleItems.filter((item) => !canRedirect(item)),
//   ];
//   const sportsItem = sortedItems.find((item) => item?.label === "Sports");

//   if (!sportsItem) {
//     return sortedItems;
//   }

//   const itemsWithoutSports = sortedItems.filter((item) => item?.label !== "Sports");
//   const offersIndex = itemsWithoutSports.findIndex((item) => item?.label === "Offers");

//   if (offersIndex === -1) {
//     return [...itemsWithoutSports, sportsItem];
//   }

//   return [
//     ...itemsWithoutSports.slice(0, offersIndex + 1),
//     sportsItem,
//     ...itemsWithoutSports.slice(offersIndex + 1),
//   ];
// };


export const arrangeSidebarMenuItems = (items = []) => {
  const hiddenSidebarLabels = ["Games", "More"];

  const normalizedItems = items.map((item) => {
    if (item?.label === "Sports") {
      return {
        ...item,
        path: "/sports",
        externalUrl: undefined,
        openInNewTab: undefined,
        requiresLogin: false,
        isPublic: true,
      };
    }

    if (
      item?.label === "Offers" &&
      !item.path &&
      !item.externalUrl &&
      !item.action
    ) {
      return {
        ...item,
        path: "/offers",
      };
    }

    return item;
  });

  return normalizedItems.filter(
    (item) => !hiddenSidebarLabels.includes(item?.label)
  );
};
export const openSidebarExternalUrl = (item) => {
  if (!item?.externalUrl) return;

  if (item.openInNewTab) {
    window.open(item.externalUrl, "_blank", "noopener,noreferrer");
    return;
  }

  window.location.href = item.externalUrl;
};
